var exports = {
  "C": "xe564cbfb--604df2--onboarding-anchor",
  "Y": "xe564cbfb--604df2--onboarding-content",
};

module.exports = exports;
